import { COMMAND_CHAIN_COMPLETED, COMMAND_CHAIN_STARTED } from './types';

export const doCommandChainStarted = (type: string, requestId: string) => ({
    type: COMMAND_CHAIN_STARTED,
    payload: {
        type,
        id: requestId
    }
});
export const doCommandChainCompleted = (type: string, requestId: string) => ({
    type: COMMAND_CHAIN_COMPLETED,
    payload: {
        type,
        id: requestId
    }
});

export type CommandChainActionOutcomes =
    | {
          type: typeof COMMAND_CHAIN_STARTED;
          payload: {
              type: string;
              id: string;
          };
      }
    | {
          type: typeof COMMAND_CHAIN_COMPLETED;
          payload: {
              type: string;
              id: string;
          };
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          _context?: Record<string, any>;
      };
